module.exports = __webpack_public_path__ + "static/img/wxyt.afd9dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/wxyt.png
// module id = D9or
// module chunks = 4